<template>
  <div :class="$style.root">
    <div :class="$style.content">
      <div :class="$style.inputs">
        <input
          :class="[$style.input, $style.email]"
          placeholder="Email"
          v-model="email"
          type="email"
          autocomplete="off"
          @keyup.enter="subscribe"
        />
        <div :class="$style.inputsColumns">
          <input
            :class="$style.input"
            :placeholder="$t('newsletter.firstName')"
            v-model="firstName"
            autocomplete="off"
            @keyup.enter="subscribe"
          />
          <input
            :class="$style.input"
            :placeholder="$t('newsletter.lastName')"
            v-model="lastName"
            autocomplete="off"
            @keyup.enter="subscribe"
          />

        </div>

        <div :class="$style.selectContainer">
          <div :class="$style.label">
            {{ $t('newsletter.language') }}
          </div>
          <select
            :class="$style.select"
            v-model="language"
          >
            <option value="Nederlands">{{ $t('newsletter.option.nl') }}</option>
            <option value="English">{{ $t('newsletter.option.en') }}</option>
          </select>
        </div>
      </div>
      <CoreButtonsArrowComponent
        :class="$style.button"
        :disabled="!isValid ? '' : null"
        @click="subscribe"
      />
    </div>

    <div
      v-if="res?.success"
      :class="$style.message"
    >
      {{ $t('newsletter.confirmation') }}
    </div>
    <div
      v-if="res?.signedUp"
      :class="$style.message"
    >
      {{ $t('newsletter.signedUp') }}
    </div>
  </div>
</template>

<script setup>
const { locale: currentLocale } = useI18n()

const props = defineProps({
  audienceId: String
})

import isEmail from 'validator/lib/isEmail'
import isLength from 'validator/lib/isLength'
const email = ref('')
const firstName = ref('')
const lastName = ref('')
const language = ref(currentLocale.value == 'nl' ? 'Nederlands' : 'English')

const res = ref(null)
watch(res, (val) => {
  if (val) {
    setTimeout(() => {
      res.value = null
    }, 10000)
  }
})

const isValid = computed(() => {
  return isEmail(email.value) && isLength(firstName.value, { min: 1 }) && isLength(lastName.value, { min: 1 })
})

const subscribe = async () => {
  if (!isValid.value) return

  const { data } = await useFetch('/api/mailchimp', { params: { email: email.value, firstName: firstName.value, lastName: lastName.value, audienceId: props?.audienceId, language: language.value } })
  res.value = data?.value
}
</script>

<style module>
.root {
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--unit--spacer);
}

.inputs {
  display: flex;
  flex-direction: column;
  gap: var(--unit--spacer);
  flex: 1;
}

.inputsColumns {
  display: flex;
  gap: var(--unit--spacer);
}

.input {
  composes: reset-input font-size-medium from global;
  padding: .45rem .3rem 0 .3rem;
  width: calc(100% - .6rem);
  border-bottom: var(--stroke--medium) solid var(--color--secondary);
}

.input::placeholder {
  color: inherit;
}

.input:focus {
  border-color: var(--color--primary);
}

.button {
  composes: button-disabled-state from global;
  transform: rotate(180deg);
  align-self: flex-end;
}

.selectContainer {
  display: flex;
  gap: 1ch;
  align-items: baseline;
}

.label {
  composes: font-size-small font-helvetica from global;
  margin-bottom: var(--unit--spacer);
}

.select {
  composes: reset-input font-size-small font-helvetica from global;
  appearance: none;
  padding: .45rem .3rem .45rem .3rem;
  border: var(--stroke--medium) solid var(--color--secondary);
  margin-right: auto;
  text-align: center
}

.select::-ms-expand {
  display: none;
}

.message {
  composes: font-size-small font-helvetica from global;
  margin-top: var(--unit--spacer);
}
</style>
